var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class RemoteSourcesHandler {
    constructor() {
        this.sources = ['Proxy', 'TrailBlazer'];
        this.getFormattedSuperSelectOptions = (entities) => {
            return this.sources.map((source) => {
                return {
                    value: source,
                    inputDisplay: source
                };
            });
        };
    }
    listEntity() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                resolve(this.sources);
            });
        });
    }
    getFormattedComboValueOptions(entities) {
        const combos = [];
        entities.forEach((source) => {
            combos.push({
                label: source,
                value: source
            });
        });
        return combos;
    }
}
